export default __webpack_public_path__ + "static/media/cp_geo_gw.fe2fc61b.svg";